
import { translations } from '@/mixins'
import { ValidationObserver, configure } from 'vee-validate'
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import {mapGetters} from "vuex";

@Component({
    computed: {
    ...mapGetters({
      getLocale: "app/getLocale",
      // getAllowedButton: "button/getButton",
    }),
  },
  mixins: [translations]
})

export default class ConfirmCard extends Vue {

  private areaName: String = ''
  private code: String = ''
  translate!: Function

  @Prop() hasOcimsIntegration!: any
  @Prop() isSaving!: Boolean
  @Prop() activeDeliveryArea!: Object
  @Prop() deliveryAreaIsUpdating!: Boolean
  @Prop() isAdding!: Boolean

  private updateCoordinates(bol: Boolean = true) {
    this.$emit('edit:coordinates', bol)
  }

  private updateName() {
    this.$emit('edit:name')
  }

  private updateCode() {
    this.$emit('edit:code')
  }

  private updateArea() {
    this.$emit('update:coordinates')
  }

  private submitArea() {
    this.$emit('submit:area', this.areaName, this.code)
  }

  private cancel() {
    this.$emit('cancel:updates')
  }

  private deleteArea(activeDeliveryArea: any) {
    this.$emit('delete:coordinates', activeDeliveryArea);
  }
}
